import { Typography } from "@mui/material";
import { safeParseFloat } from "encamp-shared/src/utils/safeParseNumber";
import { formatNumber } from "util/formatNumber";

export type EManifestBox18a = { text?: string | null; appliesToLine: boolean };

/** The staff-confirmed Box 18a amount (pounds) when the row was resolved with it, else null. */
export function getConfirmedBox18aAmount(d: {
  status?: string | null;
  correctValueSource?: string | null;
  correctValue?: string | null;
}): string | null {
  const resolvedWithBox18a =
    d.status === "RESOLVED" && d.correctValueSource === "EMANIFEST_BOX_18A";
  return resolvedWithBox18a ? (d.correctValue ?? null) : null;
}

function formatPounds(value: string): string {
  const amount = safeParseFloat(value);
  return amount == null ? value : formatNumber(amount);
}

/**
 * Under an e-Manifest quantity: the receiving facility ticked Box 18a Quantity
 * and wrote the real amount. After staff resolve with that amount, says it now
 * replaces the e-Manifest amount in reporting.
 */
export function EManifestBox18aCaption({
  box18a,
  confirmedAmount,
}: {
  box18a: EManifestBox18a | null | undefined;
  confirmedAmount?: string | null;
}) {
  if (confirmedAmount) {
    return (
      <Typography variant="caption" color="text.secondary" display="block">
        Box 18a override confirmed: {formatPounds(confirmedAmount)} lbs, used for reporting instead
        of the e-Manifest amount
      </Typography>
    );
  }
  if (!box18a) return null;
  return (
    // pre-line keeps the line breaks ingest puts between each waste line's text.
    <Typography variant="caption" color="warning.main" display="block" whiteSpace="pre-line">
      Box 18a: quantity discrepancy
      {box18a.text ? ` "${box18a.text}"` : ""}
      {box18a.appliesToLine ? "" : " (applies to the whole manifest)"}
    </Typography>
  );
}
